import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElDialog, ElScrollbar } from 'element-plus'

import { propTypes } from '@/utils/propTypes'
import { computed, useAttrs, ref, unref, useSlots, watch, nextTick } from 'vue'
import { isNumber } from '@/utils/is'


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: propTypes.bool.def(false),
    title: propTypes.string.def('Dialog'),
    maxHeight: propTypes.oneOfType([String, Number]).def('500px')
},
  setup(__props) {

const props = __props

const slots = useSlots()



const getBindValue = computed(() => {
    const delArr: string[] = ['fullscreen', 'title', 'maxHeight']
    const attrs = useAttrs()
    const obj = { ...attrs, ...props }
    for (const key in obj) {
        if (delArr.indexOf(key) !== -1) {
            delete obj[key]
        }
    }
    return obj
})

const isFullscreen = ref(false)

const toggleFull = () => {
    isFullscreen.value = !unref(isFullscreen)
}

const dialogHeight = ref(isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight)

watch(
    () => isFullscreen.value,
    async (val: boolean) => {
        await nextTick()
        if (val) {
            const windowHeight = document.documentElement.offsetHeight
            dialogHeight.value = `${windowHeight - 55 - 60 - (slots.footer ? 63 : 0)}px`
        } else {
            dialogHeight.value = isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight
        }
    },
    {
        immediate: true
    }
)

const dialogStyle = computed(() => {
    return {
        height: unref(dialogHeight)
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), _mergeProps(_unref(getBindValue), {
    "destroy-on-close": "",
    "lock-scroll": false,
    draggable: "",
    "append-to-body": true,
    "close-on-click-modal": false,
    top: "10vh"
  }), _createSlots({
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (_unref(slots).footer)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ])
        }
      : undefined
  ]), 1040))
}
}

})